import * as dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import duration from "dayjs/plugin/duration";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { Dialog } from "vant";
import router from "@/router/index";
dayjs.locale("zh-cn");
dayjs.extend(duration);
dayjs.extend(weekOfYear);

/**
 * 日期时间格式化
 *
 * @export
 * @param {Date ｜ number ｜ string} [datetime=new Date()] 日期时间
 * @param {string} [format="YYYY-MM-DD HH:mm:ss"] 格式化模板
 * @return {string} 格式化后的日期时间
 */
export function datetimeFormat(
  datetime = new Date(),
  format = "YYYY-MM-DD HH:mm:ss"
) {
  if (typeof datetime === "number" && datetime.toString().length === 10) {
    datetime *= 1000;
  }
  return dayjs(datetime).format(format);
}

/**
 * 毫秒数格式化为日期时间
 *
 * @param {number} milliseconds 毫秒数
 * @param {string} [format="mm′ss″"] 格式化模板
 * @returns 格式化后的日期时间字符串
 */
export function durationFormat(milliseconds, format = "mm′ss″") {
  if (isNaN(milliseconds)) {
    return milliseconds;
  }
  return dayjs.duration(Number(milliseconds)).format(format);
}

// 时间戳转为10位的
export function to10(timestamp) {
  if (String(timestamp) === "") {
    return "";
  }
  if (String(timestamp).length !== 13) {
    throw "请传入13位时间戳";
  }
  return String(timestamp).substr(0, 10);
}

/**
 * 百分比
 * @param {number} val
 */
export function percentFormat(val, n = 2) {
  val = val * 100;
  n = n ? parseInt(n) : 0;
  if (n <= 0) {
    return Math.round(val);
  }
  val = Math.round(val * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
  val = Number(val).toFixed(n); //补足位数
  return val;
}

/**
 * 数字格式化
 * @param {number} num
 */
export function numberFormat(num) {
  const str = num.toString();
  const reg =
    str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, "$1,");
}

export function showNetworkError() {
  Dialog.alert({
    title: "温馨提示",
    message: "网络异常，请检查网络后重试！",
  }).then(() => {
    // on close
  });
}

export function showWebsocketClose(
  message = "连接已中断，请重新匹配！",
  btnText = "重新匹配"
) {
  Dialog.alert({
    message: message,
    confirmButtonText: btnText,
  }).then(() => {
    router.replace({
      path: "/versus/index",
      replace: true,
      query: { timestamp: Date.now() },
    });
  });
}

export function showNetworkDialog(message, btnText) {
  if (["/versus/index", "/versus/game"].includes(router.currentRoute.path)) {
    showWebsocketClose(message, btnText);
    return;
  }
}
